import React from "react"
import Carousel from "react-bootstrap/Carousel"
import Image, { GatsbyImageProps } from "gatsby-image"
import styled from "styled-components"
import Glide from "react-glidejs"

import "react-glidejs/dist/index.css"
import { ISliderOpen } from "../pages/home/PopinProjet"
import { cross } from "../../assets"

interface IProps {
  className?: string
  photos: GatsbyImageProps[]
  sliderOpen: ISliderOpen
  closeSlider: () => void
}

const Wrapper = styled.div``

const StyledGlide = styled(Glide)`
  height: 100%;
  display: flex;
  align-items: center;

  .slider__track {
    max-height: 100%;
  }

  .glide__slides {
    margin: 0;
    max-height: 100vh;
    align-items: center;
  }

  .glide__slide {
    margin: 0;
    flex-shrink: 1;
    flex-grow: 0;
    max-height: 100vh;

    & > .gatsby-image-wrapper {
      max-height: 100vh;
    }
  }

  .Glide-leftArrow,
  .Glide-rightArrow {
    top: initial;
  }
`

const SliderImage = styled(Image)``

const Button = styled.button`
  display: flex;
  align-items: center;
  position: absolute;
  margin: 0 10px;
  padding: 10px 20px;
  top: 0;
  right: 0;
  z-index: 1;
  font-size: var(--font-size-sm);
  text-transform: uppercase;
  border: none;
  background: var(--color-light);
  color: var(--color-grey-1);

  img {
    width: 13px;
    margin-left: 20px;
  }

  &:hover {
    opacity: 0.7;
  }
`

const Slider = ({
  className,
  photos,
  sliderOpen,
  closeSlider,
}: IProps) => {
  return (
    <Wrapper className={className}>
      <StyledGlide
        startAt={sliderOpen.selected}
        type="carousel"
        perView={1}
        peek={{
          before: 50,
          after: 50,
        }}
        slideClassName="slider__frame"
        focusAt="center"
      >
        {photos.map((photo, i) => {
          return (
            <SliderImage
              fluid={photo.fluid}
              alt={`${photo} - aperçu ${i}`}
              imgStyle={{
                objectFit: "contain",
                maxHeight: "100vh",
              }}
              key={i}
            />
          )
        })}
      </StyledGlide>
      <Button onClick={closeSlider}>
        <span>Fermer</span>
        <img src={cross} alt="Fermer" />
      </Button>
    </Wrapper>
  )
}

export default Slider
